import { availableMedias } from '@/utils/mtype';

const dic = {
    state: {
        industryTree: [],
        businessTree: [],
        allIndustryTree: [],
        allThirdIndustryTree: [],
        mediaTypeTree: [],
        regionTree: [],
        availableMedias: availableMedias()
    },
    mutations: {
        SET_INDUSTRY: (state, lsit) => {
            state.industryTree = lsit;
        },
        SET_BUSINESS: (state, lsit) => {
            state.businessTree = lsit;
        },
        SET_THIRDINDUSTRYTREE: (state, lsit) => {
            state.allThirdIndustryTree = lsit;
        },
        SET_MEDIATYPE: (state, lsit) => {
            state.mediaTypeTree = lsit;
        },
        SET_REGION: (state, lsit) => {
            state.regionTree = lsit;
        }
    },
    actions: {
        SetIndustry: ({ commit }, list) => {
            commit('SET_INDUSTRY', list);
        },
        SetBusiness: ({ commit }, list) => {
            commit('SET_BUSINESS', list);
        },
        SetThirdIndustry: ({ commit }, list) => {
            commit('SET_THIRDINDUSTRYTREE', list);
        },
        SetMediaType: ({ commit }, list) => {
            commit('SET_MEDIATYPE', list);
        },
        SetRegionType: ({ commit }, list) => {
            commit('SET_REGION', list);
        }
    }
};

export default dic;
